import { all } from 'redux-saga/effects';
// Sagas
import { saga as authSaga } from './duck/authDuck';
import { saga as passwordSaga } from './duck/passwordDuck';
import { saga as userConsentSaga } from './duck/userConsentDuck';
import { saga as ecgTestsSaga } from './duck/ecgTestsDuck';
import { saga as patchEcgsSaga } from './duck/patchEcgsDuck';
import { saga as eventsSaga } from './duck/eventsDuck';
import { saga as medicalStaffsSaga } from './duck/medicalStaffsDuck';
import { saga as reportsSaga } from './duck/reportsDuck';
import { saga as reportSaga } from './duck/reportDuck';
import { saga as deviceSummarySaga } from './duck/deviceSummaryDuck';
import { saga as deviceEcgTotalSaga } from './duck/deviceEcgDuck';
import { saga as patientEventsSaga } from './duck/patientEventsDuck';
import { saga as testResultSaga } from './duck/testResultDuck';
import { saga as beatReviewSaga } from './duck/beatReviewDuck';
import { saga as hrReviewSaga } from './duck/hrReviewDuck';

export default function* rootSaga() {
  yield all([
    authSaga(),
    passwordSaga(),
    userConsentSaga(),
    ecgTestsSaga(),
    patchEcgsSaga(),
    eventsSaga(),
    medicalStaffsSaga(),
    reportsSaga(),
    reportSaga(),
    deviceSummarySaga(),
    deviceEcgTotalSaga(),
    patientEventsSaga(),
    testResultSaga(),
    beatReviewSaga(),
    hrReviewSaga(),
  ]);
}
